module.exports = __webpack_public_path__ + "static/media/icon_plus.9e1b82bc.svg";